import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from './shared.service';

@Injectable()
export class BookingService {
  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  private pdfOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/pdf')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log error to console

      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }

  public getFranchisePrices(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getFranchisePrices', []))
    );
  }

   public getGuestFranchisePrices(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/guest/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getFranchisePrices', []))
    );
  }

  public getInstitutionPrices(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/institution/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getInstitutionPrices', []))
    );
  }

  public getDomesticInstitutionPrices(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/institution/domestic/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getInstitutionPrices', []))
    );
  }

  public getBusinessUserPrices(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/business-user/domestic/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getBusinessUserPrices', []))
    );
  }

  public getBusinessUserExportPrices(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/business-user/export/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getBusinessUserPrices', []))
    );
  }

  public getMauritiusDomesticRates(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/mauritius/domestic/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getMauritiusDomesticRates', []))
    );
  }


  public getMauritiusExportRates(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/mauritius/export/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getMauritiusDomesticRates', []))
    );
  }

   public getMauritiusExportSARates(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/mauritius/export/sa/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getMauritiusDomesticRates', []))
    );
  }


  public getImportQuote(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/import/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getImportQuote', []))
    );
  }

   public getGuestImportQuote(quoteBody: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'rate/engine/import/guest/quote', quoteBody, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getImportQuote', []))
    );
  }

  

  public createBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createMauritiusBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/mauritius/domestic/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

   public createMauritiusExportBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/mauritius/export/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createMauritiusExportSABooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/mauritius/export/sa/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public updateBookingAddress(bookingDetails: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'booking/update/address', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

   public updatePickupBookingAddress(bookingDetails: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'booking/update/pick-up-address', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }


  public updateDropoffBookingAddress(bookingDetails: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'booking/update/drop-off-address', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public updateParcelDetails(id:any, bookingDetails: any): Observable<any> {
    return this.http.put(this.sharedService.getFranchiseUrl() + 'booking/'+id+'/update/parcel-details', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }
  

  

  public createTakealotBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/takealot/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createTakealotBooking', []))
    );
  }

  public createGuestRTMCBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/guest/rtmc/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createSpecializedQuote(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/import/speacialize-quote', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createInstitutionBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/create/reseller', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createInstituionImportBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/import/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createInstitutionBulkBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/create/bulk', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  

  public createImportBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/import/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public createGuestBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/guest/create', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  public sendProformaData(proformaData: any, bookingTrackNo: string): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/' + bookingTrackNo + '/create/proforma', proformaData, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('sendProformaData', []))
    );
  }

  public sendInstitutionProformaData(proformaData: any, bookingTrackNo: string): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/' + bookingTrackNo + '/create/proforma', proformaData, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('sendProformaData', []))
    );
  }

  public payBookingWithWallet(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/process/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

   public confirmPeachPayment(id:any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/peach-payment/process/' + id, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

  public payImportBookingWithWallet(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/process/import/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

  public payDTCBookingWithWallet(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/process/counter/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

  public getUserBookings(userId: any, filter: any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/user/'+userId,filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getUserBookings', []))
    );
  }

  public getUserBookingsWithFilters(filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/user/filter', filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getUserBookingsWithFilters', []))
    );
  }

  public generateReport(filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/export',filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateReport', []))
    );
  }

  public generateInstitutionReport(selectedInstitution : any,selectedStore : any,filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'institution/booking/export/'+selectedInstitution+'/'+selectedStore,filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateInstitutionReport', []))
    );
  }

  public submitSalesCode(userId:any,obj:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/submit/salescode/'+userId,obj,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('submitSalesCode', []))
    );
  }

  public submitGuestSalesCode(obj:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/salescode',obj,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('submitSalesCode', []))
    );
  }

  public downloadReport(fileId:any):any {
    return this.sharedService.getFranchiseUrl() + 'booking/report/download/'+fileId;

  }

  public getBooking(bookingId:any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'booking/'+bookingId, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getBooking', []))
    );
  }

  public submitProforma(file: any, bookingTrackNo: string): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/' + bookingTrackNo + '/submit/proforma/file', file, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('submitProforma', []))
    );
  }

  public submitInsitutionProforma(file: any, bookingTrackNo: string): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/' + bookingTrackNo + '/submit/proforma/file', file, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('submitProforma', []))
    );
  }

  public trackbooking(trackNo:string): Observable<any> {
    return this.http.get(`${this.sharedService.getFranchiseUrl()}booking/track/${trackNo}`, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('trackbooking', []))
    );
  }

  public trackShipment(trackNo:string): Observable<any> {
    return this.http.get(`${this.sharedService.getFranchiseUrl()}booking/track/shipment/${trackNo}`, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('trackbooking', []))
    );
  }

  public trackMauritiusbooking(trackNo:string): Observable<any> {
    return this.http.get(`${this.sharedService.getFranchiseUrl()}booking/frontier-force/track/${trackNo}`, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('trackbooking', []))
    );
  }
  /*public cancelBooking(bookingId:string): Observable<any> {
    return this.http.post(`${this.sharedService.getFranchiseUrl()}booking/cancel/${bookingId}`, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('cancelBooking', []))
    );
  }*/
  public cancelBooking(data: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/cancel', data, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('cancelBooking', []))
    );
  }

  public cancelResellerBooking(data: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/reseller-booking/cancel', data, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('cancelBooking', []))
    );
  }

  public userStats(userId: any, months: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'booking/stats/'+userId+'/months/'+months , {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('userStats', []))
    );
  }

  public userBookingStats(userId: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'booking/stats/'+userId , {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('userStats', []))
    );
  }

  public userBookingStatsWithFilter(userId: any,filter:any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/stats/'+userId ,filter, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('userStats', []))
    );
  }

  public userInstitutionBookingStats(insID: any,storeId:any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/booking/stats/'+insID+'/'+ storeId, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('userStats', []))
    );
  }

  public institutionBookingStats(insID: any,storeId:any, filter:any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/stats/'+insID+'/'+ storeId, filter, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('userStats', []))
    );
  }

  public completeBooking(bookingId:any): Observable<any> {
    return this.http.put(
      this.sharedService.getFranchiseUrl() + 'booking/complete/'+bookingId,'',
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('completeBooking', []))
    );
  }

  public downloadWaybill(bookingTrackNo:string):Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'booking/download/waybill/'+bookingTrackNo, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadWaybill', []))
    );
  }

  
   public downloadMauritiusLabel(bookingTrackNo:string):Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'booking/download/label/'+bookingTrackNo, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadLabel', []))
    );
  }

  public saveAsLabel(bookingTrackNo:string,obj:any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/custom-label/download/'+bookingTrackNo, obj, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadLabel', []))
    );
  }

  public downloadResellerWaybill(bookingTrackNo:string):Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'institution/booking/download/waybill/'+bookingTrackNo, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadWaybill', []))
    );
  }

  public emailTaxInvoice(taxDetails: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/send/tax/invoice', taxDetails, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('emailTaxInvoice', []))
    );
  }

  public downloadTaxInvoice(taxDetails: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/download/tax/invoice', taxDetails, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadTaxInvoice', []))
    );
  }

  public emailInstitutionTaxInvoice(taxDetails: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/send/tax/invoice', taxDetails, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadTaxInvoice', []))
    );
  }

  public downloadInstitutionTaxInvoice(taxDetails: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/download/tax/invoice', taxDetails, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadTaxInvoice', []))
    );
  }

  public downloadBulkInstitutionTaxInvoice(instition:any,store:any,user:any,taxDetails: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/'+instition+'/store/'+store+'/tax-invoices/send-for-user/'+user, taxDetails, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadTaxInvoice', []))
    );
  }
  getZonosCategories():Observable<any>  {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'test/zonos/categories',{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('getZonosCategories', []))
    );
  }

  public getZonosVatAndDuties(commodityItem: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'test/zonos', commodityItem, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('getZonosVatAndDuties', []))
    );
  }

  public getImportZonosVatAndDuties(commodityItem: any):Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'test/import/zonos', commodityItem, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('getZonosVatAndDuties', []))
    );
  }

  getHSCodes(request:any):Observable<any>  {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'test/zonos/classify/object',request,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('getHSCodes', []))
    );
  }

  getLoadedWallet(walletId: string):Observable<any>  {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'payment/wallet/' + walletId,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('getLoadedWallet', []))
    );
  }

  getBookings(selectedInstitutionId: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/booking/all/'+selectedInstitutionId,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getBookings', []))
    );
  }

  public declineImportBooking(bookingDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/import/quote/decline', bookingDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createBooking', []))
    );
  }

  getStoreBookings(selectedInstitutionId: any,selectedStore:any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/booking/all/'+selectedInstitutionId+'/'+selectedStore,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getBookings', []))
    );
  }

  validateSecureDetails(formData: any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'skysecure/validation', formData, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('getSkySecureValidation', []))
    );
  }

  getBookingsWithFilter(selectedInstitution: any, selectedStore: string, page: number, size: number): Observable<any>  {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'institution/booking/all/'+selectedInstitution+ '/'+selectedStore+'/'
    +page+'/'+size, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getBookings', []))
    )
  }

  getTaxDetails(selectedUserId: string): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'booking/vat/details/'+ selectedUserId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getTaxDetails', []))
    );
  }

  saveTaxDetails(selectedUserId: string, taxDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/save/vat/details/' + selectedUserId, taxDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('saveTaxDetails', []))
    );
  }

  verifyAddress(address: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/verify/postal/suburb', address, this.jsonOptions).pipe(
      catchError(this.handleError<any>('verifyAddress', []))
    );
  }

  getAllPostalCodes(): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'addressbook/postal/suburb', this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllPostalCodes', []))
    );
  }

  getUserBookingsInRange(obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'booking/user/filter/range',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getUserBookingsWithFilters', {})),
    );
  }

  public payBulkBookingWithWallet(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/process/reseller-booking/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

  public receiveAtCounter(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/status/update/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

   public payInstitutionCounterBookingWithWallet(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/process/reseller-booking/counter/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

  public getInsitutionBookingsWithFilters(institutionId :any, storeId:any, filter:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'institution/booking/all/'+institutionId+'/'+storeId, filter,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getUserBookingsWithFilters', []))
    );
  }

  public payImportInstitutionBookingWithWallet(bookingTrackNumber: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'institution/booking/process/import-booking/' + bookingTrackNumber, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('payBookingWithWallet', []))
    );
  }

  public bulkLabelPrinting(bookingIds:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/bulk/label/printing',bookingIds,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateReport', []))
    );
  }

  public bulkWaybillPrinting(bookingIds:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'booking/bulk/waybill/printing',bookingIds,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateReport', []))
    );
  }

  public institutionBulkLabelPrinting(bookingIds:any): Observable<any> {
    return this.http.post(
      this.sharedService.getFranchiseUrl() + 'institution/booking/bulk/label/printing',bookingIds,
      this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('generateReport', []))
    );
  }

  public registerStore(storeDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'v1/store/register', storeDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('registerStore', []))
    );
  }

  public getRegisteredStores(userId: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'website-integration/stores/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getRegisteredStores', []))
    );
  }

  public downloadInstructions(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'website-integration/instructions', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('downloadInstructions', []))
    );
  }


  public downloadLabel(bookingTrackNo:string):Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'booking/label/download/'+bookingTrackNo, {
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any[]>('downloadLabel', []))
    );
  }

  public emailTaxInvoicesForDateRange(taxDetails: any):Observable<any> {
     return this.http.post(this.sharedService.getFranchiseUrl() + 'booking/tax-invoices/send-for-user/'+taxDetails.oid,taxDetails).pipe(
      catchError(this.handleError<any[]>('downloadInstructions', []))
    );
  }

}
